<template>
    <div class="container container--facture-list">

        <Loader v-if="!isReady"></Loader>

        <List v-else
            :filtering="this"
            :itemNameSingular="'facture'"
            :itemNamePlural="'factures'" >
            
            <template v-slot:actions>
                    
                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>
                    
            </template>

            <template v-slot:filters>

                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher un n°, engagement, etc."/>
                </ListFilter>
                <ClientFilter v-model="filters.client_id"
                    :clients="clients"/>
                <DateFilter v-model="dates" />

            </template>

            <template v-slot:heading>
                <div class="cell cell--main criteria">
                    <Sorter criteria="num">Numéro</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="clientCode">Client</Sorter>
                </div>
                <div class="cell criteria">                                
                    <Sorter criteria="engagementNum">Ref. client</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="createdAt">Émise le</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="expiredAt">À régler le</Sorter>
                </div>
                <div class="cell"></div>
                <div class="cell cell--price criteria">
                    <Sorter criteria="amountHT">Total HT</Sorter>
                </div>
                <div class="cell cell--price criteria">                                                              
                    <Sorter criteria="amountTTC">Total TTC</Sorter>
                </div>
            </template>

            <div class="list__content facture-list" v-if="hasContent">

                <li class="list__content__item"
                    v-for="facture in items"
                    :key="facture.id">

                    <ListItem class="list-item--card"
                        :item="facture"
                        :route="route">
                        <div class="cell cell--main">
                            <strong>{{ facture.num }}</strong>
                        </div>
                        <div class="cell cell--secondary">{{ facture.clientCode }}</div>
                        <div class="cell cell--secondary">{{ facture.engagementNum }}</div>
                        <div class="cell cell--date"><Date :date="facture.createdAt" /></div>
                        <div class="cell cell--date cell--secondary"><Date v-if=facture.expiredAt :date="facture.expiredAt" /></div>
                        <div class="cell cell--state"><Badge type="danger" v-if="facture.amountRemaining > 0 && facture.isExpired">En retard</Badge></div>
                        <div class="cell cell--price cell--secondary"><Price :amount="facture.amountHT" :currency="facture.currency" /></div>
                        <div class="cell cell--price"><Price :amount="facture.amountTTC" :currency="facture.currency" /></div>
                    </ListItem>

                </li>

            </div>
            
            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucune facture</h1>
            </div>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les factures suivantes</button>
            </div>

        </List>


    </div>
</template>

<script>
import { mapState } from 'vuex'

import Badge from '@/components/badge/Badge.vue'
import Button from '@/components/button/Button.vue'
import ClientFilter from '@/components/list/filters/ClientFilter.vue'
import Date from '@/components/date/Date.vue'
import DateFilter from "@/components/list/filters/DateFilter.vue"
import List, { ListFilter, ListItem, Sorter }  from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'
import Price from '@/components/price/Price.vue'

import api from '@/api/proxyWeb/factures'
import { routes } from '@/router'

import filtering from "@/containers/filtering"
import  { useClientAddresses } from '@/helpers/clientAddress'

export default {

    name: 'FactureList',

    data: function() {
        return {
            filters: {
                client_id: null,
                from: null,
                to: null,
                query: ''
            },
            route: routes.FACTURE,
            processingXlsx: false
        }
    },

    computed: {
        
        ...mapState({

            clients: state => state.clients.all,

            clientAddresses: function(state) {
                return useClientAddresses(state.clients.all, this.filters.client_id)
            },

            markets: state => state.sites.markets

        })
    },
  
    methods: {
        
        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        }, 
                
    },

    created () {
        this.useFilter(api)
    },

    components: {
        Badge,
        Button,
        ClientFilter,
        Date,
        DateFilter,
        List,
        ListFilter,
        ListItem,
        Loader,
        Price,
        Sorter
    },

    mixins: [ filtering ]
}
</script>

<style scoped>

.table {
    width: 100%;
}

.table__action {
    color: #17a2b8;
}

.table__data {}

.table__data--main {
    font-weight: 700;
}

.table__data--no-result {
    text-align: center;
    opacity: 0.8;
}

.table__row {
    cursor: pointer;
}

</style>
